import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../config/config";

export const RentReadings = createAsyncThunk(
  "bill/RentReading",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      let response;

      if (id) {
        // Update an existing rent bill record
        response = await axios.post(
          `${BASE_URL}/update-rent-reading/${id}`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
      } else {
        // Create this cycle's rent bill record
        response = await axios.post(`${BASE_URL}/rent-reading`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const RentReading = createSlice({
  name: "RentReading",
  initialState: {
    loading: false,
    RentReading: [],
    error: "",
  },
  extraReducers: {
    [RentReadings.fulfilled]: (state, action) => {
      state.RentReading = action.payload;
      state.loading = false;
    },
    [RentReadings.pending]: (state) => {
      state.loading = true;
    },
    [RentReadings.rejected]: (state, action) => {
      state.error = action.error.message;
      state.loading = false;
    },
  },
});
export default RentReading.reducer;
